export { PLUGIN_KEY, PLUGIN_PRIORITY, NestedRows } from "./nestedRows.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/nestedRows/index.mjs
// module id = 1530
// module chunks = 1